import { render, staticRenderFns } from "./StatisticsCards.vue?vue&type=template&id=7a398e5c"
import script from "./StatisticsCards.vue?vue&type=script&lang=js"
export * from "./StatisticsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports